import Workshops from "../components/Workshops";

export default function WorkshopsPage() {
  return (
    <section className="py-10">
      <Workshops />
    </section>
  );
}
